import { Component, Input, OnInit } from '@angular/core';
import { CidaasService } from '../../../../service/cidaas.service';
import { SharedDataService } from '../../../../service/shared-data.service';

@Component({
  selector: 'app-social-login-provider',
  templateUrl: './social-login-provider.component.html',
  styleUrls: ['./social-login-provider.component.scss'],
})
export class SocialLoginProviderComponent implements OnInit {
  // variable declarations
  @Input() providers!: string[];
  contentLoading: boolean = false;
  constructor(private _dataService: SharedDataService, private _cidaasSDK: CidaasService) {}

  ngOnInit(): void {}

  // social login
  _socialLogin = (provider: string) => {
    this.contentLoading = true;
    this._dataService._getRequestId().subscribe(async (data) => {
      try {
        await this._cidaasSDK._socialLogin({ requestId: data, provider: provider });
      } catch (e) {
      }
      this.contentLoading = false;
    }, () => {
      this.contentLoading = false;
    });
  }
}
